function checkGetCookie(name)
{
  var pos
  var token = name + "=";
  var tnlen = token.length;
  var cklen = document.cookie.length;
  var i = 0;
  var j;
  while (i < cklen)
  { j = i + tnlen;
    if (document.cookie.substring(i, j) == token)
    { pos = document.cookie.indexOf (";", j);
      if (pos == -1)
        pos = document.cookie.length;
      return unescape(document.cookie.substring(j, pos));
    }
    i = document.cookie.indexOf(" ", i) + 1;
    if (i == 0) break;
  } //End While
  return null;
}

function checkSetCookie(name, value)
{ 
     document.cookie = name + "=" + escape(value)
}

function checkDeleteCookie(name)
{ 
  var exp = new Date();
  exp.setTime (exp.getTime() - 1);
  var cval = checkGetCookie (name);
  document.cookie = name + "=" + cval + "; expires=" + exp.toGMTString();
}


function cookiesSupported()
{

	// Test for Cookie support.  
	var gCookieName;
	var gCookieValueRet;
	gCookieName="ctCookieTestName";
	gCookieValue="ctCookieTestValue";
	gCookieValueRet="???"; // initialize retrieve value
	checkSetCookie(gCookieName,gCookieValue,1);
	gCookieValueRet=checkGetCookie(gCookieName);


	if (gCookieValueRet!==null)
		return true;
	else
		false;

}

function doCheckCookiesEnabled(tSessionID)
{
	// entry point for the test
	if (!cookiesSupported())
	{
		alert('You must allow cookies in order to checkout!');
		window.location = 'cart.aspx?sessionID=' + escape(tSessionID);
	}
}